import { render, staticRenderFns } from "./PipelineMenuWrapper.vue?vue&type=template&id=36a8a2ba&"
import script from "./PipelineMenuWrapper.vue?vue&type=script&lang=ts&"
export * from "./PipelineMenuWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports